import { jsx as _jsx } from "react/jsx-runtime";
import { Scheduler as BaseScheduler } from "sprout-ui-dom";
import { CSSTransitionPortal } from "sprout-ui-dom/dist/Portal";
import OutsideClickListener from "sprout-ui-dom/dist/internal/OutsideClickListener";
import styled from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { DialogRoot } from "./styles";
import useDialogOverlayHandlers from "./useDialogOverlayHandlers";
const dialogTimeout = {
    enter: 0,
    exit: 0
};
const Scheduler = styled(BaseScheduler)`
  box-shadow: 0 1px 4px ${themeGet("colors.black.16")};

  width: 320px;
  max-height: calc(100% - 80px);

  margin: 56px auto 24px;

  pointer-events: auto;
`;
const SchedulerDialog = (props)=>{
    const { onRequestClose , open , onScheduled , items  } = props;
    const { onExited , onEnter  } = useDialogOverlayHandlers();
    return /*#__PURE__*/ _jsx(CSSTransitionPortal, {
        open: open,
        timeout: dialogTimeout,
        onEnter: onEnter,
        onExited: onExited,
        children: /*#__PURE__*/ _jsx(OutsideClickListener, {
            onOutsideClick: onRequestClose,
            children: /*#__PURE__*/ _jsx(DialogRoot, {
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(Scheduler, {
                    onScheduled: onScheduled,
                    items: items,
                    onEscape: onRequestClose
                })
            })
        })
    });
};
export default SchedulerDialog;
